<template>
    <div class="organization">
        <section class="banner">
            <button class="btn-reset free-btn" @click.stop="handleFreeBtnClick">免费定制</button>
        </section>
        <!-- 专属定制 -->
        <section class="exclusive">
            <img src="@/assets/img/homes/organization/exclusive-title.png" alt="exclusive-title"/>
            <div class="content">
                <div class="desc">
                    <div class="desc-internet">
                        <img src="@/assets/img/homes/organization/domain.png" alt="domain" style="vertical-align: middle"/>
                        <h3 class="title">网站域名</h3>
                    </div>
                    <div class="desc-internet">
                        <img src="@/assets/img/homes/organization/company-website.png" alt="company-website" style="vertical-align: middle"/>
                        <h3 class="title">网站首页</h3>
                    </div>
                    <div class="desc-internet">
                        <img src="@/assets/img/homes/organization/company-logo.png" alt="company-logo" style="vertical-align: middle"/>
                        <h3 class="title">网站LOGO</h3>
                    </div>
                </div>
                <div class="tips">还有更多功能，专属为您定制</div>
                <div class="anli">
                    <div class="anli-desc">
                        <h2 class="title">案例</h2>
                        <div class="collage">
                            内蒙古医科大学
                            <div>培训考试服务平台</div>
                        </div>
                        <div class="collage-desc">
                            《内蒙古医科大学培训考试服务平台》是一款集：医学资源服务、机构资源库建设、课程培训学习、在线考试、APP应用于一体的综合类服务平台。
                            帮助内蒙古医科大学实现先学习再评测后考试，考后客观题自动阅卷，多维度统计分析，让组织者全面掌握考试情况。
                        </div>
                    </div>
                    <img src="@/assets/img/homes/organization/neimenggu.png" alt="neimenggu">
                </div>
            </div>
            <el-row type="flex" justify="center">
                <button class="btn-reset free-btn" style="position: static" @click.stop="handleFreeBtnClick">更多功能定制 <i class="el-icon-right" style="margin-left: 20px;font-size: 20px;"></i></button>
            </el-row>
        </section>
        <!-- 资源加工服务 -->
        <section class="resource">
            <img src="@/assets/img/homes/organization/resource-processing.png" alt="resource-processing"/>
            <h3 class="advantage">我们的优势</h3>
            <div style="text-align: center">
                <img src="@/assets/img/homes/organization/three-start.png" alt="three-start">
            </div>
            <div class="card-list">
                <div class="card">
                    <img src="@/assets/img/homes/organization/auto-production.png" alt="auto-production"/>
                    <div class="desc">30年全自动</div>
                    <div class="desc">生产加工</div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/organization/suanfa.png" alt="auto-production"/>
                    <div class="desc">算法启动</div>
                    <div class="desc">文字识别</div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/organization/rengong.png" alt="auto-production"/>
                    <div class="desc">人工精准</div>
                    <div class="desc">排查错误</div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/organization/question.png" alt="auto-production"/>
                    <div class="desc">题库资源永久储存</div>
                    <div class="desc">随时检索调取</div>
                </div>
            </div>
            <div class="text-center">
                <img src="@/assets/img/homes/organization/border.png" alt="border"/>
            </div>
            <h3 class="advantage">加工流程</h3>
            <div class="text-center">
                <img src="@/assets/img/homes/organization/three-start.png" alt="three-start"/>
            </div>
            <div class="processing-flow">
                <div class="flow">纸质文件电子扫描</div>
                <img src="@/assets/img/homes/organization/double-arrow_right.png" alt="double-arrow_right"/>
                <div class="flow">人工录入手动纠错</div>
                <img src="@/assets/img/homes/organization/double-arrow_right.png" alt="double-arrow_right"/>
                <div class="flow">生成专属题库，试卷库</div>
                <img src="@/assets/img/homes/organization/double-arrow_right.png" alt="double-arrow_right"/>
                <div class="flow">机构灵活组织考试</div>
            </div>
            <el-row type="flex" justify="center">
                <button class="btn-reset free-btn" style="position: static" @click.stop="handleFreeBtnClick">更多功能定制 <i class="el-icon-right" style="margin-left: 20px;font-size: 20px;"></i></button>
            </el-row>
        </section>
        <!-- 专属功能定制 -->
        <section class="functional">
            <img src="@/assets/img/homes/organization/functional-title.png" alt="functional-title"/>
            <div class="card-list">
                <div class="card">
                    <img src="@/assets/img/homes/organization/knowledge-icon.png" alt="knowledge"/>
                    <div class="content">
                        <h3 class="title">自定义知识点分类</h3>
                        <div class="desc">灵活调取使用机构自建资源</div>
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/organization/org-exam-icon.png" alt="org-exam-icon"/>
                    <div class="content">
                        <h3 class="title">自主组织考试</h3>
                        <div class="desc">自由选择时间、参考人群、考试方式灵活组织各项考试</div>
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/organization/quick-icon.png" alt="quick"/>
                    <div class="content">
                        <h3 class="title">便捷刷题练习</h3>
                        <div class="desc">学生可在机构自建题库，随时进行备考练习</div>
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/organization/question-icon.png" alt="question-icon"/>
                    <div class="content">
                        <h3 class="title">问卷调查</h3>
                        <div class="desc">免费赠送问卷调查功能，使机构定制平台服务更全面</div>
                    </div>
                </div>
            </div>
            <el-row type="flex" justify="center">
                <button class="btn-reset free-btn" style="position: static" @click.stop="handleFreeBtnClick">更多功能定制 <i class="el-icon-right" style="margin-left: 20px;font-size: 20px;"></i></button>
            </el-row>
        </section>
        <Dialog ref="dialog"/>
    </div>
</template>

<script>
import Dialog from "./cpns/Dialog"
export default {
    name: "organization",
    components: {
        Dialog
    },
    methods: {
        handleFreeBtnClick () {
            this.$refs.dialog.open()
        }
    }
}
</script>

<style scoped lang="less">
@import "../index";
.free-btn {
    background: linear-gradient(180deg, #F5E4C4 0%, #E8C591 100%);
    border-radius: 35px;
    width: 20%;
    color: #9A732C;
    height: 60px;
    font-size: 18px;
    position: absolute;
    bottom: 34%;
}
.banner {
    .background-image("~@/assets/img/homes/organization/banner.jpg");
    width: 100%;
    box-sizing: border-box;
    height: 787px;
    padding-left: @base-padding;
    position: relative;
}
.exclusive {
    box-sizing: border-box;
    width: 100%;
    height: 1056px;
    .background-image("~@/assets/img/homes/organization/exclusive-bg.png");
    padding: 70px @base-padding;
    position: relative;
    z-index: 1;
    border-radius: 60px 60px 0 0;
    top: -100px;
    margin-bottom: -100px;
    .content {
        .background-image("~@/assets/img/homes/organization/exclusive-border.png");
        box-sizing: border-box;
        height: 75%;
        padding: 4% 5% 5%;
        display: flex;
        flex-direction: column;
        margin-bottom: 3.8%;
        .desc {
            display: flex;
            justify-content: space-around;
            align-items: center;
            .desc-internet {
                display: flex;
                align-items: center;
                .title {
                    font-size: 30px;
                    letter-spacing: 8px;
                    margin-left: 20px;
                }
            }

        }
        .tips {
            text-align: center;
            font-size: 16px;
            color: #2F3134;
            letter-spacing: 6px;
        }
        .anli {
            background-image: linear-gradient(315deg, #FCF5E7 0%, #FEFBF5 100%);
            box-shadow: 0 2px 26px 0 rgba(154,115,44,0.1600);
            border-radius: 20px;
            box-sizing: border-box;
            flex: 1;
            margin-top: 30px;
            padding: 30px 0 30px @base-padding / 2;
            display: flex;
            justify-content: space-between;
            .anli-desc {
                width: 40%;
                box-sizing: border-box;
                .title {
                    background: linear-gradient(180deg, #F5E4C4 0%, #E8C591 100%);
                    border-radius: 0 0 40px 40px;
                    height: 60px;
                    text-align: center;
                    width: 60%;
                    letter-spacing: 6px;
                    font-size: 28px;
                    line-height: 60px;
                    margin: 0 0 20px 0;
                }
                .collage {
                    font-size: 26px;
                    line-height: 40px;
                    font-weight: 700;
                    letter-spacing: 6px;
                }
                .collage-desc {
                    font-size: 16px;
                    letter-spacing: 4px;
                    margin-top: 20px;
                }
            }
        }
    }
}
.resource {
    box-sizing: border-box;
    padding: 60px @base-padding;
    height: 1200px;
    background-image: linear-gradient(310deg, #F6F7FB 0%, #EAECF6 100%);
    .advantage {
        font-size: 36px;
        margin: 20px 0 10px;
        text-align: center;
        letter-spacing: 2px;
    }
    .card-list {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        margin-top: 20px;
        .card {
            width: 22%;
            text-align: center;
            box-sizing: border-box;
            padding: 70px 16px;
            background: linear-gradient(315deg, #FCF5E7 0%, #FEFBF5 100%);
            box-shadow: 0 8px 32px 0 rgba(154,115,44,0);
            border-radius: 26px;
            .desc {
                font-size: 24px;
                margin-top: 8px;
            }
            img {
                margin-bottom: 30px;
            }
        }
    }
    .processing-flow {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        align-items: center;
        margin: 30px 0 50px;
        .flow {
            width: 22%;
            box-sizing: border-box;
            height: 120px;
            background: #FFFFFF;
            border-radius: 60px;
            border: 18px solid #FFFBF5;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
        }
    }
}
.functional {
    width: 100%;
    box-sizing: border-box;
    padding: 40px @base-padding;
    background: #fff;
    height: 780px;
    .card-list {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 50px;
        margin-top: 53px;
        margin-bottom: 60px;
        .card {
            height: 215px;
            background: #F6F6F6;
            border-radius: 108px;
            display: flex;
            align-items: center;
            padding-left: 16%;
            .content {
                margin-left: 30px;
                .title {
                    font-size: 30px;
                    margin: 0 0 20px 0;
                }
                .desc {
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
